module.exports = __webpack_public_path__ + "static/media/login-bg.1eb0d4b2.jpg";